import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

const Navigation = ({
  user,
  onLogout,
  setIsCartOpen,
  getTotalItems,
  settings,
  table,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Extract hashcode from current URL
  const path = location.pathname.split("/")[1];
  const isUUID = /^[0-9a-fA-F-]{36}$/.test(path);
  const hashcode = isUUID ? path : null;

  const handleLogoutClick = () => {
    if (onLogout) {
      onLogout();
    }
    navigate(`/${hashcode}/login`);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark">
      <div className="container">
        {/* Brand */}
        <Link className="navbar-brand" to={`/${hashcode}`}>
          <i className="fas fa-utensils me-2"></i>
          {settings?.business_name || "Restaurant"}
        </Link>

        {/* Mobile Toggle Button */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarContent"
          aria-controls="navbarContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Collapsible Content */}
        <div className="collapse navbar-collapse" id="navbarContent">
          {/* Right Side */}
          <div className="ms-auto d-flex flex-column flex-lg-row align-items-lg-center mt-3 mt-lg-0">
            {/* Table Name */}
            <span className="navbar-text me-lg-3 mb-2 mb-lg-0">
              Table : {table?.table_name || ""}
            </span>

            {/* Not Logged In */}
            {!user && (
              <button
                className="btn btn-outline-light mb-2 mb-lg-0 me-lg-2"
                onClick={() => navigate(`/${hashcode}/login`)}
              >
                <i className="fas fa-sign-in-alt me-1"></i>
                Login
              </button>
            )}

            {/* Logged In */}
            {user && (
              <>
                {/* ===== Desktop Dropdown ===== */}
                <div className="dropdown d-none d-lg-block me-2">
                  <button
                    className="btn btn-outline-light dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <i className="fas fa-user me-1"></i>
                    {user.name || user.phone}
                  </button>

                  <ul className="dropdown-menu dropdown-menu-end">
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => navigate(`/${hashcode}`)}
                      >
                        Menus
                      </button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => navigate(`/${hashcode}/profile`)}
                      >
                        Profile
                      </button>
                    </li>

                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => navigate(`/${hashcode}/orders`)}
                      >
                        Order History
                      </button>
                    </li>

                    <li>
                      <hr className="dropdown-divider" />
                    </li>

                    <li>
                      <button
                        className="dropdown-item text-danger"
                        onClick={handleLogoutClick}
                      >
                        Logout
                      </button>
                    </li>
                  </ul>
                </div>

                {/* ===== Mobile Vertical Menu ===== */}
                <div className="d-lg-none w-100">
                  <button
                    className="btn btn-outline-light w-100 mb-2"
                    onClick={() => navigate(`/${hashcode}`)}
                  >
                    <i className="fas fa-home me-2"></i>
                    Menus
                  </button>
                  <button
                    className="btn btn-outline-light w-100 mb-2"
                    onClick={() => navigate(`/${hashcode}/profile`)}
                  >
                    <i className="fas fa-user me-2"></i>
                    Profile
                  </button>

                  <button
                    className="btn btn-outline-light w-100 mb-2"
                    onClick={() => navigate(`/${hashcode}/orders`)}
                  >
                    <i className="fas fa-history me-2"></i>
                    Order History
                  </button>

                  <button
                    className="btn btn-outline-danger w-100 mb-2"
                    onClick={handleLogoutClick}
                  >
                    <i className="fas fa-sign-out-alt me-2"></i>
                    Logout
                  </button>
                </div>
              </>
            )}

            {/* Cart Button */}
            <button
              className="btn btn-outline-light position-relative mt-2 mt-lg-0"
              onClick={() => setIsCartOpen(true)}
            >
              <i className="fas fa-shopping-cart"></i>

              {getTotalItems && getTotalItems() > 0 && (
                <span className="cart-badge">{getTotalItems()}</span>
              )}
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
